import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';
import { composePageTitle } from './Common';
import Footer from './components/Footer';
import Header from './components/Header';
import { PageUrl } from './Constants';

const CancelRefund = () => {
  return (
    <div id="main-wrapper">
      <Helmet title={composePageTitle('Cancellation & Refund Policy')} />
      <Header />
      <section className="page-header page-header-dark bg-secondary">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-8">
              <h1>Cancellation & Refund Policy</h1>
            </div>
            <div className="col-md-4">
              <ul className="breadcrumb justify-content-start justify-content-md-end mb-0">
                <li>
                  <RouterLink to={PageUrl.HOME}>Home</RouterLink>
                </li>
                <li className="active">Cancellation & Refund Policy</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <div id="content">
        <div className="container">
          <div className="bg-white shadow-md rounded p-4 mb-4">
            <h2 className="text-6">Refund Eligibility</h2>
            <ul>
              <li>

                For most major airlines, tickets become non-refundable after 24 hours from the time of purchase.
                Customers may cancel their booking within the first 24 hours at no additional cost and receive a full refund.

                If a cancellation is requested after the 24-hour window, a nominal cancellation fee will apply.
                Any refund or travel credit issued will be subject to the specific policies of the airline.

                In cases where a future travel credit is granted, it can typically be applied toward a future booking with the same airline, subject to that airline’s terms and conditions.{' '}
              </li>
              <li>
                For low-cost carriers (LCCs) such as Spirit Airlines, Frontier Airlines, Sun Country, and others, tickets are generally non-refundable once booked. These airlines enforce stricter cancellation policies, especially when the scheduled departure is within seven (7) days of the booking date.

                In such cases, refunds are typically not available, and passengers may be unable to recover any of the ticket cost. However, depending on the specific airline’s policy and the circumstances, passengers may be eligible to receive a future travel credit.

                These credits may be applied toward future bookings with the same airline, but they are not redeemable for cash and are subject to the airline’s terms, conditions, and restrictions.{' '}
              </li>
              <li>
                Please note that all cancellations—whether with major airlines or low-cost carriers—must be requested at least four (4) hours prior to the scheduled departure time.
                Cancellations made after this deadline may not be accepted or processed, and passengers risk forfeiting the full value of their ticket.{' '}
              </li>
            </ul>

            <h2 className="text-6">Ticket Cancellation Policy </h2>
            <ul>
              <li>
                We recognize that travel plans can change unexpectedly. Our cancellation policy is intended to offer clear and transparent guidance while remaining fully compliant with airline regulations and applicable fare rules. If you need to cancel a flight booking, please be aware that certain conditions and procedures will determine your eligibility and the available options.{' '}
              </li>
              <li>
                All flight cancellations are governed by the specific policies of the operating airline and the fare rules linked to your ticket. In most cases, discounted economy fares are non-refundable, meaning the base fare is not eligible for a refund upon cancellation. However, certain government-imposed taxes and fees may be refundable, depending on the airline’s individual policy. We strongly recommend reviewing the terms and conditions of your ticket prior to initiating a cancellation request.{' '}
              </li>
              <li>
                To cancel your booking, please contact our customer service team no later than four (4) hours before your scheduled departure. Providing this advance notice helps you avoid no-show penalties, which generally lead to the full forfeiture of your ticket value.

                Please note that bookings with low-cost carriers often have additional restrictions, especially for tickets purchased within seven (7) days of travel, which are typically non-refundable and non-changeable under any circumstances.
                {' '}
              </li>
              <li>
                When you submit a cancellation request through our team, we will promptly verify your eligibility with the airline and apply any relevant penalties. Please be aware that our service fees are non-refundable under all circumstances, regardless of the airline’s policies. Additionally, some heavily discounted fares may be strictly non-cancellable, so we strongly advise reviewing the fare rules carefully at the time of booking.{' '}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CancelRefund;
